import { Component, Host, h, Prop } from '@stencil/core';
import { FontType } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-labels',
  shadow: false,
})
export class UgcReviewLabels {
  @Prop() verifiedPurchase: boolean = false;
  @Prop() hasRewarded: boolean = false;
  @Prop() fontType: FontType = FontType.large;

  render() {
    return (
      <Host class="flex-row-start-center flex-wrap">
        {this.verifiedPurchase && (
          <ugc-review-verified-purchase verifiedPurchase={this.verifiedPurchase} fontType={this.fontType} />
        )}
        {this.hasRewarded && (
          <span class="flex-row-start-center">
            {this.verifiedPurchase && <span class="divider"></span>}
            <ugc-review-rewarded hasRewarded={this.hasRewarded} fontType={this.fontType} />
          </span>
        )}
      </Host>
    );
  }
}
